module.exports = __webpack_public_path__ + "static/img/right-dir.c3fe7f18.svg";